// src/admin/session.js
import Vue from 'vue'

function parseAdminSession () {
  let saved = {}
  try {
    saved = JSON.parse(localStorage.getItem('DAYZ_ADMIN') || '{}')
  } catch (e) {
    localStorage.removeItem('DAYZ_ADMIN')
  }
  if (saved && !saved.expiresAt) {
    localStorage.removeItem('DAYZ_ADMIN')
    return { token: '', admin: null, expiresAt: 0 }
  }
  if (saved && saved.expiresAt && Date.now() > saved.expiresAt) {
    localStorage.removeItem('DAYZ_ADMIN')
    return { token: '', admin: null, expiresAt: 0 }
  }
  return {
    token: saved.token || '',
    admin: saved.admin || null,
    expiresAt: saved.expiresAt || 0
  }
}

export const adminSession = Vue.observable(parseAdminSession())

export function hasValidAdminSession () {
  if (!adminSession.token) return false
  if (!adminSession.expiresAt) {
    clearAdminSession()
    return false
  }
  if (adminSession.expiresAt && Date.now() > adminSession.expiresAt) {
    clearAdminSession()
    return false
  }
  return true
}

export function setAdminSession (token, admin, expiresAtMs) {
  adminSession.token = token
  adminSession.admin = admin || null
  adminSession.expiresAt = expiresAtMs || 0
  localStorage.setItem('DAYZ_ADMIN', JSON.stringify({
    token: adminSession.token,
    admin: adminSession.admin,
    expiresAt: adminSession.expiresAt
  }))
}

export function clearAdminSession () {
  adminSession.token = ''
  adminSession.admin = null
  adminSession.expiresAt = 0
  localStorage.setItem('DAYZ_ADMIN', JSON.stringify({
    token: '',
    admin: null,
    expiresAt: 0
  }))
}
